import React, { useEffect, useState } from "react";

const StreakCounter = ({ streakCount, isCorrectAnswer }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  // Animate when streak increases
  useEffect(() => {
    if (isCorrectAnswer && streakCount > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [streakCount, isCorrectAnswer]);

  // Don't display if no streak
  if (streakCount === 0) return null;

  // Calculate color based on streak count - gradual transition from black to red
  const getColor = () => {
    // Calculate intensity from 0 (black) to 1 (full red)
    const maxStreak = 15; // At what streak count do we reach full red
    const intensity = Math.min(streakCount / maxStreak, 1);

    // Interpolate from black (0,0,0) to red (255,0,0)
    const redValue = Math.round(255 * intensity);

    return `rgb(${redValue}, 0, 0)`;
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "170px", // Position above the Links avatar
        left: "20px", // Same left position as Links avatar
        width: "clamp(100px, 25vw, 150px)", // Match width of Links avatar
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        fontFamily: "'Inter', sans-serif",
        fontWeight: "800",
        fontSize: "22px",
        color: getColor(),
        backgroundColor: "transparent", // Remove background
        transition: "transform 0.2s ease, color 0.5s ease",
        transform: isAnimating ? "scale(1.3)" : "scale(1)",
        zIndex: 3,
        textShadow: "0px 1px 2px rgba(255,255,255,0.8)", // Add text shadow to help visibility
      }}
    >
      <span style={{ fontSize: "24px" }}>🔥</span>
      <span>{streakCount}</span>
    </div>
  );
};

export default StreakCounter;
